import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { type RootState, selectors } from 'state';
import { Button, FloatingTextbox, Icon } from 'components/common';
import SavedFilterContext from './SavedFilterContext';

interface CurrentFiltersProps {
  onClear: () => void;
}

const CurrentFilters = ({ onClear }: CurrentFiltersProps) => {
  const { buttonAsideRef, handleToggle } = useContext(SavedFilterContext);
  const hasFilters = useSelector((state: RootState) => selectors.filters.hasFilters(state));

  return (
    <div className="align-items-center cursor-pointer d-flex filter filter--current justify-content-between">
      <Button
        disabled={!hasFilters}
        onClick={onClear}
        testId="filter-clear"
        text="bold"
        variant="primary-dark"
        width="block"
      >
        Clear filters
      </Button>
      <FloatingTextbox top="1.8rem" text="Saved&nbsp;Filters">
        <button
          className="btn btn-link btn-link__inline btn-reset"
          data-testid="filter-save"
          onClick={() => handleToggle('aside')}
          ref={buttonAsideRef}
          type="button"
        >
          <Icon className="ms-3 mt-1 text-1_5" name="floppy-disk" />
        </button>
      </FloatingTextbox>
    </div>
  );
};

export default CurrentFilters;
